import type { GetUserAddressesResponse } from '@/types/externals/obbsApi/users/userAddresses/Responses';
import type {
  PostUserAddressParams,
  PutUserAddressParams,
} from '@/types/externals/obbsApi/users/userAddresses/Params';

export const useUserAddress = () => {
  const userAddresses = useState<GetUserAddressesResponse>('userAddresses', () => []);

  const fetchUserAddresses = async (userId: number): Promise<void> => {
    const url: string = `/users/${userId}/user-addresses`;
    const { data, error } = await useApiFetch<GetUserAddressesResponse>(url);
    if (error.value) {
      throw createError({
        statusCode: error.value.status,
        statusMessage: error.value.title,
        message: error.value.detail,
        fatal: true,
      });
    }

    userAddresses.value = data.value;
  };

  const getUserAddresses = async (userId: number): Promise<GetUserAddressesResponse> => {
    const { data, error } = await useApiFetch<GetUserAddressesResponse>(
      `/users/${userId}/user-addresses`
    );
    if (error.value) {
      throw createError({
        statusCode: error.value.status || 404,
        statusMessage: error.value.title,
        message: error.value.detail,
        fatal: true,
      });
    }
    return data.value;
  };

  const postUserAddress = async (userId: number, params: PostUserAddressParams): Promise<void> => {
    const { error } = await useApiFetch<void>(`/users/${userId}/user-addresses`, {
      method: 'POST',
      body: params,
    });
    if (error.value) {
      throw createError({
        statusCode: error.value.status || 404,
        statusMessage: error.value.title,
        message: error.value.detail,
        fatal: true,
      });
    }
  };

  const putUserAddress = async (
    userId: number,
    userAddressId: number,
    params: PutUserAddressParams
  ): Promise<void> => {
    const { error } = await useApiFetch<void>(`/users/${userId}/user-addresses/${userAddressId}`, {
      method: 'PUT',
      body: params,
    });
    if (error.value) {
      throw createError({
        statusCode: error.value.status || 404,
        statusMessage: error.value.title,
        message: error.value.detail,
        fatal: true,
      });
    }
  };
  const deleteUserAddress = async (userId: number, userAddressId: number): Promise<void> => {
    const { error } = await useApiFetch<void>(`/users/${userId}/user-addresses/${userAddressId}`, {
      method: 'DELETE',
    });
    if (error.value) {
      throw createError({
        statusCode: error.value.status || 404,
        statusMessage: error.value.title,
        message: error.value.detail,
        fatal: true,
      });
    }
  };

  return {
    userAddresses: readonly(userAddresses),
    fetchUserAddresses,
    getUserAddresses,
    postUserAddress,
    putUserAddress,
    deleteUserAddress,
  };
};
